var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen",attrs:{"id":"app"}},[_c('router-view',{staticClass:"h-full",staticStyle:{"overflow-y":"auto"}}),_c('Navigation'),_c('Notification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }